import React from 'react';
import ChileOfferShoppingCart from '@fingo/lib/components/shopping/OfferShoppingCart/ChileOfferShoppingCart';
import { availableOffersTitles } from '@fingo/lib/constants/factoring/summary-titles';
import CHILE_OFFER_FLOW_STEP_IDS from '@fingo/lib/constants/factoring/chile-offer-flow-step-ids';
import { HEADERS, CLIENT_HEADERS, MOBILE_HEADERS } from './available-offers';

const ItauOfferShoppingCart = (props) => (
  <ChileOfferShoppingCart {...props} requireBankAccount />
);

const CONSTRAINT_DELIMITER = '::';

const getRowConstraintValue = (row) => `${row?.dteType?.id}${CONSTRAINT_DELIMITER}${row?.responsibilityType}`;

const getDisabledRowTooltip = (row, lockedConstraint) => {
  const [lockedDteTypeId, lockedResponsibilityType] = String(lockedConstraint)
    .split(CONSTRAINT_DELIMITER);
  if (String(row?.dteType?.id) !== lockedDteTypeId) {
    return 'Solo puedes seleccionar facturas del mismo tipo de documento';
  }
  if (row?.responsibilityType !== lockedResponsibilityType) {
    return 'Solo puedes seleccionar facturas con el mismo tipo de responsabilidad (con o sin responsabilidad)';
  }
  return '';
};

const getStepsConditions = ({
  offerIds,
  showConfirmationSummary,
  showCessionStep,
  cessionStepperNavigation,
}) => [
  offerIds.length === 0,
  showConfirmationSummary,
  showCessionStep,
  showCessionStep
    && cessionStepperNavigation?.stepId === CHILE_OFFER_FLOW_STEP_IDS.CESSION_TYPE_SELECTOR,
  showCessionStep && cessionStepperNavigation?.currentStep > 1,
];

const DEFAULT_HEADER = {
  headerDescription: 'Selecciona las facturas aprobadas que deseas girar.',
};

const DATE_STEP_HEADER = {
  headerTitle: 'Configura tu financiamiento',
  headerDescription: 'Define el plazo de pago y revisa el monto estimado que recibirás.',
};

const CESSION_STEP_HEADER = {
  headerTitle: 'Cesión de facturas',
  headerDescription: 'Elige cómo ceder las facturas de tu empresa y dónde recibir el pago.',
};

const getStepHeader = ({ showCessionStep, showConfirmationSummary }) => {
  if (showCessionStep) return CESSION_STEP_HEADER;
  if (showConfirmationSummary) return DATE_STEP_HEADER;
  return DEFAULT_HEADER;
};

const OPTIONS = {
  summaryDataInfo: availableOffersTitles.summaryDataInfoChile,
  headers: HEADERS,
  mobileHeaders: MOBILE_HEADERS,
  clientHeaders: CLIENT_HEADERS,
  summaryActionButtonText: availableOffersTitles.summaryActionButtonTextChile,
  ShoppingCartComponent: ItauOfferShoppingCart,
  showInformationStack: true,
  useSelectDaysButtons: true,
  minDaysFromToday: 10,
  getDisabledRowTooltip,
  getRowConstraintValue,
  getStepsConditions,
  getStepHeader,
};

export default OPTIONS;
